import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../../../components/ui/dialog";
import { Button } from "../../../components/ui/button";

const ModalOverlay = ({
  isOpen,
  filterQuestion,
  modalFilterConfig,
  minValue,
  maxValue,
  setModalFilterConfig,
  applyFilter,
  clearFilter,
  closeFilterModal,
}) => {
  if (!filterQuestion) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && closeFilterModal()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Filtrar: {filterQuestion.question}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          {filterQuestion?.type === "Solo permite números"
            ? "Arrastra los valores mínimo y máximo utilizando los puntos en la línea."
            : filterQuestion?.type === "Respuesta de Sí o No"
            ? "Selecciona las respuestas que deseas ver."
            : "Selecciona los valores deseados."}
        </p>

        {filterQuestion && filterQuestion.type === "Solo permite números" && (
          <div className="pt-6">
            <div className="relative h-1.5">
              {/* Línea visible del slider */}
              <div className="absolute inset-0 rounded-full bg-muted" />

              {/* Línea resaltada de intersección */}
              <div
                className="absolute h-full rounded-full bg-primary"
                style={{
                  left: `${
                    (((modalFilterConfig.min || minValue) - minValue) /
                      (maxValue - minValue)) *
                    100
                  }%`,
                  width: `${
                    (((modalFilterConfig.max || maxValue) -
                      (modalFilterConfig.min || minValue)) /
                      (maxValue - minValue)) *
                    100
                  }%`,
                }}
              />

              {/* Input para el mínimo */}
              <input
                type="range"
                min={minValue}
                max={
                  Math.max(modalFilterConfig.max || maxValue, minValue + 1) - 1
                } // Aseguramos un rango válido
                value={modalFilterConfig.min || minValue}
                onChange={(e) => {
                  const newMin = Math.min(
                    parseFloat(e.target.value),
                    (modalFilterConfig.max || maxValue) - 1 // Usa maxValue como fallback
                  );
                  setModalFilterConfig((prev) => ({
                    ...prev,
                    min: newMin,
                  }));
                }}
                className="absolute top-1/2 -translate-y-1/2 appearance-none bg-transparent accent-primary"
                style={{
                  width: `${
                    (((modalFilterConfig.max || maxValue) - minValue) /
                      (maxValue - minValue)) *
                    100
                  }%`,
                }}
              />

              {/* Input para el máximo */}
              <input
                type="range"
                min={minValue} /* Mantiene el rango global */
                max={maxValue}
                value={modalFilterConfig.max || maxValue}
                onChange={(e) => {
                  const newMax = Math.max(
                    parseFloat(e.target.value),
                    modalFilterConfig.min + 1
                  );
                  setModalFilterConfig((prev) => ({
                    ...prev,
                    max: newMax,
                  }));
                }}
                className="absolute top-1/2 right-0 -translate-y-1/2 appearance-none bg-transparent accent-primary"
              />
            </div>
            <div className="mt-6 flex justify-between text-xs text-muted-foreground">
              <span>Min: {modalFilterConfig.min || minValue}</span>
              <span>Max: {modalFilterConfig.max || maxValue}</span>
            </div>
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={clearFilter}>
            Limpiar filtro
          </Button>
          <Button variant="outline" onClick={closeFilterModal}>
            Cerrar
          </Button>
          <Button onClick={applyFilter}>Aplicar filtro</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ModalOverlay;
